import React from 'react';
import PropTypes from 'prop-types';
import {Helmet} from "react-helmet";
import {withRouter, Redirect, Route, Switch} from 'react-router-dom';
import IndexChartsSidebar from "./IndexChartsSidebar";
import TraceBASICharts from "../Charts/TraceBASICharts";
import TraxBASICharts from "../Charts/TraxBASICharts";
import SPPCharts from "../Charts/SPPCharts";
import './IndexCharts.scss';

const IndexCharts = (props) => {

    const { match } = props;

    return (
            <div className="indexChartsPage">

                <Helmet>
                    <title>Index Center | MarketAxess</title>
                </Helmet>

                <div className="indexCharts__wrapper container" style={{marginTop: '70px', marginBottom: '70px'}}>

                    <IndexChartsSidebar path={match.path} />

                    <main className="indexCharts__main">
                        <Switch>

                            {/* Redirect old trace-basi routes */}
                            <Route path={`${match.path}/trace-basi`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/CPP-basi/4`} />
                            )}/>
                            <Route path={`${match.path}/trace-basi/4`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/CPP-basi/4`} />
                            )}/>
                            <Route path={`${match.path}/trace-basi/5`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/CPP-basi/5`} />
                            )}/>

                            {/* CPP-basi */}
                            <Route exact path={`${match.path}/CPP-basi/:id`} component={TraceBASICharts} />
                            <Route path={`${match.path}/CPP-basi`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/CPP-basi/4`} />
                            )}/>

                            {/* Trax-basi */}
                            <Route exact path={`${match.path}/trax-basi/:id`} component={TraxBASICharts} />
                            <Route path={`${match.path}/trax-basi`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/trax-basi/0`} />
                            )}/>

                            {/* SPP */}
                            <Route exact path={`${match.path}/spp/:id`} component={SPPCharts} />
                            <Route path={`${match.path}/spp`} component={() => (
                                <Redirect from={match.path} to={`${match.path}/spp/0`} />
                            )}/>
                     
                            {/* Default Route to /index-center/CPP-basi/0 */}
                            <Route path={`${match.path}`} exact component={() => (
                                <Redirect from={match.path} to={`${match.path}/CPP-basi/4`} />
                            )}/>

                        </Switch>
                    </main>

                </div>

            </div>
    );
};

IndexCharts.propTypes = {
    // eslint-disable-next-line react/forbid-prop-types
    match: PropTypes.object.isRequired
};

export default withRouter(IndexCharts);



// WEBPACK FOOTER //
// ./frontend/pages/IndexCharts/IndexCharts.jsx